import React from "react";
import { Fragment } from "react";
import PropTypes from "prop-types";
import SwipeableViews from "react-swipeable-views";
import { withTheme, withStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Typography from "@material-ui/core/Typography";
import CardContent from "@material-ui/core/CardContent";
import TextField from "@material-ui/core/TextField";
import GridItem from "components/Grid/GridItem.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import Icon from "@material-ui/core/Icon";
import extendedTablesStyle from "assets/jss/material-dashboard-pro-react/views/extendedTablesStyle.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import ReactTable from "react-table";
import { createMuiTheme } from "@material-ui/core/styles";
import green from "@material-ui/core/colors/green";
import Select from "react-select";
import originalMoment from "moment";
import { extendMoment } from "moment-range";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import axios from "../../../config/axios";
import Tooltip from "@material-ui/core/Tooltip";
import IconButton from "@material-ui/core/IconButton";
// import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { EditorState } from "draft-js";
import { connect } from "react-redux";
import tick from "../../../assets/img/tick.svg";
import reject from "../../../assets/img/close.svg";
import DeleteModel from "../../../components/Common/FevoModels/DeleteModel";
import toastr from "toastr";
import {
  Button,
  FormControl,
  MenuItem,
  InputLabel,
  // Select,
} from "@material-ui/core";
// import _ from "lodash";
import loaderIcon from "../../../assets/img/loader.gif";
import {
  getEventBookings$,
  getAllEvents$,
  // getEventAttendees$
} from "../../../redux/actions/event";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import ClearButton from "components/CustomButtons/Button";

toastr.options = {
  closeButton: true,
};

const moment = extendMoment(originalMoment);
const formStyle = {
  minWidth: 300,
  margin: "0 1.2rem 1.2rem 0",
};
const modules = {
  toolbar: [
    [{ header: [1, 2, 3, 4, 5, 6, false] }],
    [{ font: [] }],
    ["bold", "italic", "underline", "strike"], // toggled buttons
    [{ align: [] }],
    [{ color: [] }, { background: [] }],
    ["image"],
    //['link', 'image', 'video'],
    //[{ 'header': 1 }, { 'header': 2 }],               // custom button values
    [{ script: "sub" }, { script: "super" }], // superscript/subscript
    [{ list: "ordered" }, { list: "bullet" }],
    [{ indent: "-1" }, { indent: "+1" }], // outdent/indent
    ["blockquote", "code-block"],
    //[{ 'direction': 'rtl' }],                         // text direction
    //[{ 'size': ['small', false, 'large', 'huge'] }],  // custom dropdown
    ["clean"], // remove formatting button
  ],
};

const userOptions = [
  { value: "normal", label: "Normal" },
  { value: "student", label: "Student" },
  { value: "government", label: "SG Government" },
];

const ticketOptions = [
  { value: "EARLY_BIRD", label: "Early Bird Price" },
  { value: "NORMAL", label: "Normal Price" },
  { value: "STUDENT", label: "Student Price" },
  { value: "GROUP", label: "Group booking Price" },
  // { value: 'coupan', label: 'Complimentary(Booking done via coupon code)' },
];

const fiter_style = {
  display: "flex",
  justifyContent: "space-around",
};
function TabContainer({ children, dir }) {
  return (
    <Typography
      component="div"
      dir={dir}
      style={{
        padding: 8 * 3,
      }}
    >
      {children}
    </Typography>
  );
}

TabContainer.propTypes = {
  children: PropTypes.node.isRequired,
};

class EventDetail extends React.Component {
  state = {
    activeTab: 0,
    amount: null,
    appovedUser: [],
    allowedBannerCount: 10,
    categoryList: [],
    name: "",
    event_images: null,
    category_name: [],
    speakerList: [],
    speaker_name: null,
    speaker_bio: null,
    speaker_image: null,
    location: null,
    start_date: null,
    end_date: null,
    price: null,
    id:
      this.props.location.state &&
      this.props.location.state.event &&
      this.props.location.state.event.id,
    brief_desc: null,
    // redirected : null,
    // redirected_event_id:this.props.history.location.state.redirected_event_id,
    remaining_tickets: null,
    booked_tickets: null,
    pending_tickets : null,
    editorState: EditorState.createEmpty(),
    total_tickets: null,
    date: new Date().getTime(),
    manageRequests: [],
    vipUsers :[],
    manageRequestsUsers: [],
    bookingDetails: [],

    showModal: false,
    booking_id: null,
    showModalReject: false,
    survey_hash: "",
    speaker_details: [],
    eventId: "",
    paymentTitle: "",
    showPaymentModel: false,
    loading: false,
    attendeesCount: 0,
    event_type: "",
    group_booking_price: null,
    student_price: null,
    normal_price: null,
    actual_seats: null,
    waiting_tickets: null,
    early_bird_price: null,
    expiry_date: null,
    verificationTitle: "",
    showVerificationModel: false,
    booking_status: "",
    selected_user_type: null,
    selected_ticket_type: null,
    seatsToBeChangedValue: null,
    seatsToBeChanged: null,
    showAcceptModal: false,
    popText: null,
    waitingSeats: null,
    remaining_vip_seats:null,
    vip_seats: null,
    ticketTypeList: [
      { value: "NORMAL", label: "NORMAL" },
      { value: "EARLY_BIRD", label: "EARLY_BIRD" },
      { value: "STUDENT", label: "STUDENT" },
      { value: "GROUP", label: "GROUP" },
      { value: "COUPON", label: "COUPON" },
    ],
    userTypeList: [
      { value: "NORMAL", label: "NORMAL" },
      { value: "VIP", label: "VIP" },
      { value: "GOVERNMENT", label: "GOVERNMENT" },
    ],
    ticket_type: "",
    user_type: "",
    user_type_manageRequest: "",
    ticket_type_manageRequest: "",
  };

  componentDidMount = () => {
    if (this.props.location.state) {
      const { event } = this.props.location.state;
      let {
        name,
        amount,
        start_date,
        end_date,
        location,
        price,
        total_tickets,
        event_speaker,
        event_category,
        event_images,
        brief_desc,
        editor,
        id,
        survey_hash,
        event_type,
        group_booking_price,
        student_price,
        normal_price,
        early_bird_price,
        expiry_date,
      } = event;
      console.log("999999999", event);
      // debugger;
      console.log(this.props.location.state, "this.props.location.state");
      this.getEvents(id);
      this.getUnapprovedEvents(id);
      this.getVIPSeatsForEvent(id)
      

      let speaker_name = [];
      for (let i = 0; i < event_speaker.length; i++) {
        speaker_name.push({
          value: event_speaker[i].speaker.id,
          label: event_speaker[i].speaker.name,
        });
      }
      //debugger;
      let category_name = [];
      // const speaker_name = { value: speaker.id, label: speaker.name };
      const image = event_images.length > 0 ? event_images[0].path : null;
      for (let i = 0; i < event_category.length; i++) {
        category_name.push({
          value: event_category[i].name,
          label: event_category[i].name,
        });
      }
      const speaker_image =
        event_speaker.speaker_images && event_speaker.speaker_images.length > 0
          ? event_speaker.speaker_images[0].path
          : null;
      this.setState({
        ...this.state,
        name,
        amount,
        start_date: moment(new Date(start_date), "LLL"),
        end_date: moment(new Date(end_date), "LLL"),
        location,
        price,
        total_tickets,
        speaker_name,
        speaker_bio: event_speaker.bio,
        speaker_image,
        brief_desc,
        category_name,
        event_images: image,
        // remaining_tickets,
        // booked_tickets,
        // pending_tickets,
        id,
        survey_hash,
        speaker_details: event_speaker,
        eventId: id,
        editorState: editor ? editor : null,
        event_type,
        // waitingSeats: waiting_seats,
        // waiting_tickets,
        group_booking_price: group_booking_price ? group_booking_price : null,
        student_price: student_price ? student_price : null,
        normal_price: normal_price ? normal_price : null,
        early_bird_price: early_bird_price ? early_bird_price : null,
        expiry_date: expiry_date ? moment(new Date(expiry_date), "LLL") : null,
      });
      this.props.handleGetEventList();
      this.props.handleGetEventBookings(id);
      this.getAllEventSeatsData(id)

      // this.getTotalPendingTickets();
    }
  };

  getSeatTicket = () => {
    // console.log('inside getSeatTicket')
  };

  getAllEventSeatsData = async (eventId) => {
      console.log(eventId,' event id')
     await axios
      .get(
        `events/${eventId}`
      )
      .then((res) => {
        if (res.status === 200 || res.status === 201) {
          const { data } = res;
          this.setState({
            ...this.state,
            actual_seats: data && data.data && data.data.actual_seats,
            booked_tickets : data && data.data && data.data.booked_tickets,
            remaining_tickets : data && data.data && data.data.remaining_tickets,
            waitingSeats : data && data.data && data.data.waiting_seats,
            waiting_tickets : data && data.data && data.data.waiting_tickets,
            booked_tickets : data && data.data && data.data.booked_tickets,
            remaining_vip_seats : data && data.data && data.data.remaining_vip_seats,
            vip_seats : data && data.data && data.data.remaining_vip_seats


          });
          console.log(data,'responseData in getAllEventSeatsData')
  
          }
      });
  }

  getTotalPendingTickets = (bookingList) => {

    
    let total_pending_tickets = 0;
    bookingList && bookingList.map((booking) => {
      if( (booking.ticket_status === 'PENDING' && booking.ticket_type === 'STUDENT' ) 
         || 
        (booking.registrant_type === 'GOVERNMENT' && booking.ticket_status === 'PENDING')
      ){
        total_pending_tickets = total_pending_tickets + 1;
      }
    })

    this.setState({
      ...this.state,
      pending_tickets : total_pending_tickets
    })
  }

  getEvents = (id) => {
    axios.get(`booking/events/${id}/normal/APPROVED`).then((res) => {
      if (res.status === 200) {
        let count = res.data.data.attendee_count;
        let data = res.data.data.bookingList;
        let attendeesDetails = [];
        let bookingDetails = [];
        this.setState({
          ...this.state,
          appovedUser: data,
        });
        res.data.data.bookingList.map((item, index) => {
          if (item.attendee_status == "CHECKED-IN") {
            attendeesDetails.push(item);
          } else {
            bookingDetails.push(item);
          }
        });
        this.setState({
          ...this.state,
          attendeesCount: count,
          attendeesDetails: attendeesDetails,
          bookingDetails: bookingDetails,
        });
      } else {
      }
    });
  };

  getUnapprovedEvents = (id) => {
    // .get(`booking/unapproved/events/${id}`)
    axios
      .get(`booking/events/${id}/normal/REJECTED,CANCELED,WAITING,PENDING`)
      .then((res) => {
        if (res.status === 200) {
          let data = res.data.data;
          this.getTotalPendingTickets(data.bookingList)
          this.setState({
            ...this.state,
            manageRequests: data.bookingList,
            manageRequestsUsers: data.bookingList,
          });
          // console.log("vv", res.data.data);
        }
      })
      .catch((error) => {
        // debugger;
        toastr.error(error.response.data.message);
      });
  };
  getVIPSeatsForEvent = (id) => {
    // .get(`booking/unapproved/events/${id}`)
    debugger
    axios
      .get(`booking/events/${id}/vip/APPROVED`)
      .then((res) => {
        if (res.status === 200) {
          let data = res.data.data;
          console.log(data,'data of VIP')
          debugger
          this.setState({
            ...this.state,
            vipUsers: data.bookingList,
            // manageRequestsUsers: data.bookingList,
          });
          // console.log("vv", res.data.data);
        }
      })
      .catch((error) => {
        // debugger;
        toastr.error(error.response.data.message);
      });
  };

  updatePaymentStatus = () => {
    const { booking_id, ticket_type, amount } = this.state;
    let cashier_id = localStorage.getItem("id");
    // let last_name = localStorage.getItem("name")
    let type =
      this.props.location.state &&
      this.props.location.state.event &&
      this.props.location.state.event.status == "ADMIN_CANCELLED"
        ? "refunded"
        : "received";

    let event =
      this.props.location.state &&
      this.props.location.state.event &&
      this.props.location.state.event;

    // let amt=ticket_type == 'normal' ? event.normal_price : ticket_type == 'student' ? event.student_price : ticket_type == 'earlybird' ? event.early_bird_price : ticket_type=='group' ? event.group_booking_price : ''
    let amt = parseInt(amount);

    // console.log(amt,type,'amount and type on updatePaymentStatus')

    axios
      .put(
        `booking/updatePaymentStatus?booking_id=${booking_id}&received_amount=${amt}&cashier_id=${cashier_id}&payment_type=${type}`
      )
      .then((res) => {
        if (
          (res && res.data && res.data.status === 200) ||
          res.data.status == 201
        ) {
          toastr.success("Payment Status has been Updated successfully!");
        } else {
          toastr.error(toastr.error(res && res.data.message));
        }
        // this.setState({
        //   ...this.state,
        //   loading:false,
        //   // activeTab:1
        // })
        setTimeout(() => {
          // this.props.history.push("/admin/manageevents/eventdetail");
          window.location.reload();
        }, 1500);
      })
      .catch((err) => {
        if (err.response) {
          toastr.error(err.response.data.message);
        }
        // toastr.error(err.message)
      });

    this.setState({
      ...this.state,
      loading: false,
      activeTab: 1,
    });
  };

  handleTab = (activeTab = 0) => {
    this.setState({
      activeTab,
    });
  };

  updateEventBookingStatus = () => {
    const { booking_id, booking_status, id } = this.state;
    const { event } = this.props.location.state;

    const msg = `Booking ${booking_status.toUpperCase()} Successfully`;

    // axios.put(`zoom/updateTicketStatus/${booking_id}/${booking_status}`)
    // .then(res=>{
    //   if(res && res.data && res.data.status===200 || res.data.status===200)
    //   {
    //     toastr.success(`Ticket has been ${booking_status} Successfully!`)
    //     setTimeout(()=>{
    //       window.location.reload()
    //       },1000)
    //   }
    //   else
    //   {
    //     toastr.error(toastr.error(res && res.data.message))
    //     setTimeout(()=>{
    //       window.location.reload()
    //       },1000)
    //   }
    // })
    // .catch(err=>{
    //   toastr.error(err)
    // })

    axios
      .post(
        `booking/update/bookingsdetailsperBookingID/${booking_id}/${booking_status}`
      )
      .then((res) => {
        if (res.data.status === 200 || res.data.status === 201) {
          this.setState({
            loading: false,
            booking_id: null,
            activeTab: 3,
          });
          // toastr.success(res.data.message);
          toastr.success(msg);

          this.getUnapprovedEvents(id);
          localStorage.setItem("eventRedirect", true);

          setTimeout(() => {
            this.props.history.push("/admin/manageevents/eventdetail", {
              redirect: true,
              event,
              redirected_event_id: event.id,
            });
            window.location.reload()
          }, 1500);
        } else if (res.data.status === 204) {
          this.setState({
            loading: false,
            booking_id: null,
            activeTab: 3,
          });
          toastr.error(res.data.message);
        }
      })
      .catch((error) => {
        this.setState({
          loading: false,
          booking_id: null,
          activeTab: 3,
        });
        toastr.error(error.response.data.message);
      });
  };

  getBookingTableColumn = () => {
    const { classes } = this.props;
    const theme = createMuiTheme({
      palette: {
        primary: green,
      },
    });
    let column = [
      {
        width: 120,
        Header: "User Type",
        accessor: "user_type",
        // accessor:"ticket_type",

        Cell: (event) => {
          return (
            <span>
              {event.original.registrant_type == "NORMAL"
                ? "Normal"
                : event.original.registrant_type == "STUDENT"
                ? "Student"
                : event.original.registrant_type == "GOVERNMENT"
                ? "Government"
                : event.original.registrant_type}
            </span>
          );
        },
      },
      {
        width: 120,
        Header: "Ticket Type",
        // accessor:"user_type",
        accessor: "ticket_type",

        Cell: (event) => {
          return (
            <div className="action-center">
              <span>
                {event.original.ticket_type}
                {event.original.ticket_type == "STUDENT" &&
                event.original.payment_mode == "online" ? (
                  <Tooltip title="Online" disableFocusListener>
                    <IconButton color="primary" className={classes.button}>
                      <Icon>credit_card</Icon>
                    </IconButton>
                  </Tooltip>
                ) : event.original.ticket_type == "STUDENT" &&
                  event.original.payment_mode == "offline" ? (
                  <Tooltip title="Offline" disableFocusListener>
                    <IconButton color="primary" className={classes.button}>
                      <Icon>receipt</Icon>
                    </IconButton>
                  </Tooltip>
                ) : null}
              </span>
            </div>
          );
        },
      },
      {
        width: 150,
        Header: "Booking ID",
        accessor: "booking_alias_id",
      },

      {
        width: 170,
        Header: "Customer Name",
        accessor: "name",
        Cell: (event) => {
          // console.log(event.original.user_registration_details[0].first_name,'event.original.organisation')
          return (
            <div style={{ textAlign: "center" }}>
              <span>
                {event.original.user_registration_details[0].first_name}
              </span>
            </div>
          );
        },
      },

      {
        width: 170,
        Header: "Email",
        accessor: "email",
        Cell: (event) => {
          // console.log(event.original,'event.original.organisation')
          return (
            <div style={{ textAlign: "center" }}>
              <span>{event.original.user_registration_details[0].email}</span>
            </div>
          );
        },
      },

      {
        width: 150,
        Header: "Organization",
        accessor: "organisation",
        Cell: (event) => {
          return (
            <div style={{ textAlign: "center" }}>
              <span>
                {event.original.user_registration_details[0].org
                  ? event.original.user_registration_details[0].org
                  : "NA"}
              </span>
            </div>
          );
        },
      },
      {
        width: 150,
        Header: "Designation",
        accessor: "designation",
        Cell: (event) => {
          return (
            <div style={{ textAlign: "center" }}>
              <span>
                {event.original.user_registration_details[0].designation
                  ? event.original.user_registration_details[0].designation
                  : "NA"}
              </span>
            </div>
          );
        },
      },
      {
        width: 150,
        Header: "Industry",
        accessor: "industry",
        Cell: (event) => {
          return (
            <div style={{ textAlign: "center" }}>
              <span>
                {event.original.user_registration_details[0].industry
                  ? event.original.user_registration_details[0].industry
                  : "NA"}
              </span>
            </div>
          );
        },
      },
      {
        width: 170,
        Header: "Contact No.",
        accessor: "mobile",
        // Cell: data => {
        //   // return data.original.extension + " " + data.original.mobile
        //   return data.original.extension === null
        //   ? "0" + " " + data.original.mobile
        //   : data.original.extension + " " + data.original.mobile;
        // }

        Cell: (event) => {
          return (
            <div style={{ textAlign: "center" }}>
              <span>
                {event.original.user_registration_details[0].mobile
                  ? event.original.user_registration_details[0].mobile
                  : "NA"}
              </span>
            </div>
          );
        },
      },
      {
        width: 150,
        Header: "No. of Seats",
        // accessor: "total_booked_tickets"
        Cell: (props) => {
          return (
            <div style={{ textAlign: "center" }}>
              {props.original.total_booked_tickets === 0
                ? props.original.total_waiting_tickets
                : props.original.total_booked_tickets}
            </div>
          );
        },
      },
      {
        Header: "Price",
        accessor: "total_price",
        Cell: (event) => {
          // return event.original.total_price>=0 ? `$ ${event.original.total_price}` : "Free"
          return event.original.unit_price >= 0
            ? `$ ${event.original.unit_price}`
            : "Free";
        },
      },

      {
        width: 150,
        Header: "Ticket status",
        accessor: "ticket_status",
        Cell: (props) => {
          return (
            <div>
              {props.original.user_type != "NORMAL" &&
              props.original.ticket_status === "PENDING" ? (
                <div className="actions-center">
                  <Button
                    disabled
                    variant="contained"
                    color="primary"
                    size="small"
                    className={classes.button}
                    style={{ marginRight: "10px" }}
                    onClick={() => {
                      this.setState({
                        showVerificationModel: true,
                        // showModal: true,
                        booking_id: props.original.id,
                        booking_status: "approved",
                        verificationTitle:
                          "Do you want to approved the Verification of this booking ?",
                      });
                    }}
                  >
                    Accept
                  </Button>

                  <Button
                    variant="outlined"
                    color="primary"
                    size="small"
                    className={classes.button}
                    onClick={
                      () => {
                        this.setState({
                          showVerificationModel: true,
                          // showModalReject : true,
                          booking_id: props.original.id,
                          booking_status: "rejected",
                          verificationTitle:
                            "Do You want to reject the Verification of this booking ?",
                        });
                      }
                      // ()=>this.updateBookingStatus(props.original.uuid,"rejected")
                    }
                  >
                    Reject
                  </Button>
                </div>
              ) : (
                <div style={{ marginLeft: "21%" }}>
                  {" "}
                  <span>
                    {props.original.ticket_status == "APPROVED"
                      ? "Approved"
                      : props.original.ticket_status == "PENDING"
                      ? "Pending"
                      : props.original.ticket_status}
                  </span>
                </div>
              )}
            </div>
          );
        },
      },
      {
        width: 170,
        Header: "Booking Status",
        accessor: "booking_status",
        Cell: (event) => {
          return (
            <div style={{ marginLeft: "20%" }}>
              {" "}
              <span>
                {event.original.booking_status == "WAITING"
                  ? "Waiting"
                  : event.original.booking_status == "CONFIRMED"
                  ? "Confirmed"
                  : event.original.booking_status}
              </span>
            </div>
          );
        },
      },

      {
        width: 170,
        Header: "Payment Status",
        accessor: "payment_status",
        Cell: (props) => {
          return (
            <div>
              {props.original.ticket_status === "APPROVED" &&
              props.original.payment_mode === "offline" &&
              props.original.payment_status === "PENDING" ? (
                <div className="actions-center">
                  <Button
                    color="primary"
                    disabled={
                      props.original.payment_mode === "offline" &&
                      props.original.booking_status === "CANCELED"
                        ? true
                        : false
                    }
                    variant="contained"
                    size="small"
                    onClick={
                      () => {
                        this.setState({
                          showPaymentModel: true,
                          booking_id: props.original.id,
                          ticket_type: props.original.ticket_type,
                          amount: props.original.total_price,
                          paymentTitle: `Have You Recieved $${props.original.total_price} for this event Booking ?`,
                        });
                      }
                      //()=>this.updatePaymentStatus(props.original.uuid,props.original.ticket_type)
                    }
                  >
                    Payment received
                  </Button>
                </div>
              ) : (
                <div>
                  {props.original.ticket_status == "CANCELED" &&
                  props.original.payment_status === "SUCCESSFUL" ? (
                    // props.original.booking_status =="CANCELED" && props.original.payment_status ==="SUCCESSFUL" ?
                    <span>
                      {
                        //  props.original.payment_status
                      }
                      {
                        <div className="actions-center">
                          <Button
                            color="primary"
                            variant="contained"
                            size="small"
                            className={classes.button}
                            style={{ marginLeft: "0%" }}
                            onClick={
                              () => {
                                this.setState({
                                  showPaymentModel: true,
                                  booking_id: props.original.id,
                                  ticket_type: props.original.ticket_type,
                                  amount: props.original.total_price,
                                  paymentTitle:
                                    "Are you Sure you want to initiate refund Amount for this webinar Booking ?",
                                });
                              }
                              // ()=>this.updatePaymentStatus(props.original.uuid,props.original.ticket_type)
                            }
                          >
                            REFUND
                          </Button>
                        </div>
                      }
                    </span>
                  ) : (
                    <div
                      style={{
                        // marginLeft: "25%"
                        textAlign: "center",
                      }}
                    >
                      <span>
                        {props.original.ticket_status === "APPROVED" &&
                        props.original.payment_status == "SUCCESSFUL" ? (
                          "Paid"
                        ) : (
                          <div>
                            <span>
                              {props.original.payment_status === "NOT_REQUIRED"
                                ? "Not Required"
                                : props.original.payment_status == "PENDING"
                                ? "Pending"
                                : props.original.payment_status}
                            </span>
                          </div>
                        )}
                      </span>
                    </div>
                  )}
                </div>
              )}
            </div>
          );
        },
      },
      {
        Header: "Actions",
        accessor: "actions",
        sortable: false,
        filterable: false,
        headerStyle: { textAlign: "center" },
        Cell: (event) => {
          return (
            <div className="actions-center">
              <Button
                color="primary"
                variant="contained"
                size="small"
                onClick={(e) => {
                  // console.log(event,'e in onclick')
                  e.stopPropagation();
                  // console.log("87878788")
                  this.props.history.push(
                    "/admin/manageevent/eventregistrationDetails",
                    {
                      event: event.row,
                    }
                  );
                }}
              >
                View
              </Button>
            </div>
          );
        },
      },
    ];
    return column;
  };

  getAttendeesTableColumn = () => {
    // const { classes } = this.props;
    const theme = createMuiTheme({
      palette: {
        primary: green,
      },
    });
    let column = [
      {
        Header: "Customer Name",
        accessor: "name",
      },
      {
        Header: "Email",
        accessor: "email",
      },
      {
        Header: "Organization",
        accessor: "organisation",
      },
      {
        Header: "Designation",
        accessor: "designation",
      },
      {
        Header: "Industry",
        accessor: "industry",
      },
      {
        Header: "Contact No.",
        accessor: "mobile",
        Cell: (data) => {
          // return data.original.extension + " " + data.original.mobile
          return data.original.extension === null
            ? "0" + " " + data.original.mobile
            : data.original.extension + " " + data.original.extension;
        },
      },
      {
        Header: "No. of Seats",
        // accessor: "total_booked_tickets"
        Cell: (props) => {
          return props.original.total_booked_tickets === 0
            ? props.original.total_waiting_tickets
            : props.original.total_booked_tickets;
        },
      },
      {
        Header: "Price",
        Cell: (props) => {
          return props.original.total_price
            ? `${props.original.currency + props.original.total_price}`
            : "Free";
        },
      },
      {
        Header: "Status",
        accessor: "attendee_status",
      },
    ];
    return column;
  };

  getVIPBookingColumn = () => {
    const { classes } = this.props;

    const theme = createMuiTheme({
      palette: {
        primary: green,
      },
    });
    let column = [
      // {
      //   width: 200,
      //   Header: <span style={{ textAlign: "left" }}>User Type</span>,
      //   accessor: "user_type",
      //   Cell: (props) => {
      //     return (
      //       <span>
      //         {props.original.user_type == "NORMAL"
      //           ? "Normal"
      //           : props.original.user_type == "STUDENT"
      //           ? "Student"
      //           : props.original.user_type == "GOVERNMENT"
      //           ? "Government"
      //           : props.original.user_type == "VIP"
      //           ? "Vip"
      //           : props.original.user_type}
      //       </span>
      //     );
      //   },
      // },
      {
        width: 150,
        Header: "Ticket Type",
        accessor: "ticket_type",
        Cell: (props) => {
          return (
            <div style={{ marginLeft: "20%" }}>
              <span>
                {props.original.ticket_type == "NORMAL"
                  ? "Normal"
                  : props.original.ticket_type == "STUDENT"
                  ? "Student"
                  : props.original.ticket_type == "EARLY_BIRD"
                  ? "Early bird"
                  : props.original.ticket_type == "GROUP"
                  ? "Group"
                  : props.original.ticket_type == "VIP"
                  ? "Vip"
                  : props.original.ticket_type}{" "}
              </span>
            </div>
          );
        },
      },
      {
        width: 270,
        Header: "Name",
        Cell: (  {original} ) => {
          const { user_registration_details } = original;
          const { first_name,last_name} = user_registration_details && user_registration_details[0]
          console.log(user_registration_details,first_name,last_name,'hjfjkdj')
          const fullName =
            first_name && last_name
              ? `${first_name} ${last_name}`
              : first_name
              ? first_name
              : "N/A";
          const name =
            first_name === last_name
              ? first_name
              : `${first_name} ${last_name}`;
          return <span>{name}</span>;
        },
      },
      {
        width: 250,
        Header: "Organization Id",
        // accessor: "org",
        Cell : ({original}) => {
          const { user_registration_details } = original;
          console.log(user_registration_details[0].org,'user_registration_details[0].org')
          return <span>{user_registration_details &&user_registration_details[0].org}</span>
        }
      },
      {
        width: 200,
        Header: "Booking Id",
        accessor: "main_booking_id",
      },
      {
        width: 220,
        Header: "Booking Date and Time",
        Cell: (props) => {
          return (
            <span>
              {" "}
              {props.original &&
                moment(props.original.created_date).format(
                  "DD MMM YYYY, h:mm a"
                )}
            </span>
          ); //"DD MMM YYYY, h:mm a"
        },
      },

      {
        width: 170,
        Header: "Actions",
        Cell: (event) => {
          return (
            <div className="actions-center">
              <Button
                color="primary"
                variant="contained"
                size="small"
                className={classes.button}
                onClick={(e) => {
                  e.stopPropagation();
                  this.props.history.push(
                    "/admin/manageevent/eventregistrationDetails",
                    {
                      event: event.row,
                    }
                  );
                }}
              >
                View
              </Button>
            </div>
          );
        },
      },
    ];
    return column;
  };
  getManageRequestTableColumn = () => {
    const { classes } = this.props;
    const theme = createMuiTheme({
      palette: {
        primary: green,
      },
    });
    let column = [
      {
        width: 120,
        Header: "User Type",
        // accessor:"user_type",
        accessor: "ticket_type",
        Cell: (event) => {
          return (
            <span>
              {event.original.registrant_type == "NORMAL"
                ? "Normal"
                : event.original.registrant_type == "STUDENT"
                ? "Student"
                : event.original.registrant_type == "GOVERNMENT"
                ? "Government"
                : event.original.registrant_type}
            </span>
          );
        },
      },
      {
        width: 130,
        Header: "Ticket Type",
        // accessor:"user_type",
        accessor: "ticket_type",

        Cell: (event) => {
          return (
            <span>
              {event.original.ticket_type}
              {event.original.ticket_type == "STUDENT" &&
              event.original.payment_mode == "online" ? (
                <Tooltip title="Online" disableFocusListener>
                  <IconButton color="primary" className={classes.button}>
                    <Icon>credit_card</Icon>
                  </IconButton>
                </Tooltip>
              ) : event.original.ticket_type == "STUDENT" &&
                event.original.payment_mode == "offline" ? (
                <Tooltip title="Offline" disableFocusListener>
                  <IconButton color="primary" className={classes.button}>
                    <Icon>receipt</Icon>
                  </IconButton>
                </Tooltip>
              ) : null}
            </span>
          );
        },
      },

      {
        width: 150,
        Header: "Booking ID",
        accessor: "booking_alias_id",
      },

      {
        minWidth: 180,
        Header: "Customer Name",
        accessor: "name",
        Cell: (event) => {
          return (
            <div style={{ textAlign: "center" }}>
              <span>
                {event.original.user_registration_details[0].first_name}
              </span>
            </div>
          );
        },
      },
      {
        Header: "Email",
        accessor: "email",
        Cell: (event) => {
          return (
            <div style={{ textAlign: "center" }}>
              <span>{event.original.user_registration_details[0].email}</span>
            </div>
          );
        },
      },

      {
        minWidth: 180,
        Header: "Organization",
        accessor: "organisation",
        Cell: (event) => {
          return (
            <div style={{ textAlign: "center" }}>
              <span>
                {event.original.user_registration_details[0].org
                  ? event.original.user_registration_details[0].org
                  : "NA"}
              </span>
            </div>
          );
        },
      },
      {
        minWidth: 180,
        Header: "Industry",
        accessor: "industry",
        Cell: (event) => {
          return (
            <div style={{ textAlign: "center" }}>
              <span>
                {event.original.user_registration_details[0].industry
                  ? event.original.user_registration_details[0].industry
                  : "NA"}
              </span>
            </div>
          );
        },
      },
      {
        minWidth: 180,
        Header: "Contact No.",
        accessor: "mobile",
        // Cell: data => {
        //   // return data.original.extension + " " + data.original.mobile
        //   return data.original.extension === null
        //   ? "0" + " " + data.original.mobile
        //   : data.original.extension + " " + data.original.mobile;
        // }
        Cell: (event) => {
          return (
            <div style={{ textAlign: "center" }}>
              <span>
                {event.original.user_registration_details[0].mobile
                  ? event.original.user_registration_details[0].mobile
                  : "NA"}
              </span>
            </div>
          );
        },
      },
      // {
      //   Header: "Event Type",
      //   accessor: "event_type"
      // },
      {
        Header: "No. of Seats",
        // accessor: "total_booked_tickets"
        Cell: (props) => {
          return props.original.total_booked_tickets === 0
            ? props.original.total_waiting_tickets
            : props.original.total_booked_tickets;
        },
      },

      {
        Header: "Price",
        // Cell: props => {
        //   return props.original.total_price
        //     ? `${props.original.currency + props.original.total_price}`
        //     : "Free";
        // }

        Cell: (event) => {
          return event.original.unit_price >= 0
            ? `$ ${event.original.unit_price}`
            : "Free";

          // event.original.total_price
          //   ? `$ ${event.original.total_price}`
          //   : "Free";
        },
      },

      {
        width: 160,
        Header: "Ticket status",
        accessor: "ticket_status",
        Cell: (props) => {
          return (
            <div>
              {props.original.user_type != "NORMAL" &&
              props.original.ticket_status === "PENDING" ? (
                <div className="actions-center">
                  {/* <Tooltip title="BookingCanceled" disableFocusListener> */}

                  <Button
                    disabled={
                      props.original.booking_status == "CANCELED" ? true : false
                    }
                    variant="contained"
                    color="primary"
                    size="small"
                    className={classes.button}
                    style={{ marginRight: "10px" }}
                    onClick={() => {
                      this.setState({
                        showVerificationModel: true,
                        // showModal: true,
                        booking_id: props.original.id,
                        booking_status: "approved",
                        verificationTitle:
                          "Do you want to approved the Verification of this booking ?",
                      });
                    }}
                  >
                    {props.original.ticket_type != "STUDENT"
                      ? "Accept"
                      : "Approve"}
                  </Button>

                  <Button
                    variant="outlined"
                    color="primary"
                    size="small"
                    className={classes.button}
                    //  disabled
                    disabled={
                      props.original.booking_status == "CANCELED" ? true : false
                    }
                    onClick={
                      () => {
                        this.setState({
                          showVerificationModel: true,
                          // showModalReject : true,
                          booking_id: props.original.id,
                          booking_status: "rejected",
                          verificationTitle:
                            "Do You want to reject the Verification of this booking ?",
                        });
                      }
                      // ()=>this.updateBookingStatus(props.original.uuid,"rejected")
                    }
                  >
                    Reject
                  </Button>
                  {/* </Tooltip> */}
                </div>
              ) : (
                <div style={{ marginLeft: "21%" }}>
                  {" "}
                  <span>
                    {props.original.ticket_status == "APPROVED"
                      ? "Approved"
                      : props.original.ticket_status == "PENDING"
                      ? "Pending"
                      : props.original.ticket_status}
                  </span>
                </div>
              )}
            </div>
          );
        },
      },
      {
        width: 170,
        Header: "Booking Status",
        accessor: "booking_status",
        Cell: (event) => {
          return (
            <div style={{ marginLeft: "20%" }}>
              {" "}
              <span>
                {event.original.booking_status == "WAITING"
                  ? "WAITING"
                  : event.original.booking_status == "CONFIRMED"
                  ? "CONFIRMED"
                  : event.original.booking_status}
              </span>
            </div>
          );
        },
      },

      {
        width: 150,
        Header: "Payment Status",
        accessor: "payment_status",
      },

      {
        Header: "Actions",
        accessor: "actions",
        minWidth: 250,
        sortable: false,
        filterable: false,
        headerStyle: { textAlign: "center", width: "150px" },
        Cell: (event) => {
          return (
            <React.Fragment>
              {event.original.ticket_status != "REJECTED" &&
              event.original.booking_status != "WAITING" ? (
                // event.original.booking_status == "WAITING" ?
                <div
                  className="actions-center
             button_main"
                >
                  {/* <span className="accept">
                <img
                  onClick={() =>
                    this.changeStatus(
                      this.state.manageRequests[event.index].booking_id
                    )
                  }
                  src={tick}
                  alt="tick"
                />
              </span> */}

                  {/* <Button
                color="primary"
                variant="contained"
                size="small"
                style={{ 
                  minWidth: "55px", 
                  fontSize : "12px",
                  // marginLeft: "6%"
                }}
                onClick={() =>
                  this.changeStatus(
                    this.state.manageRequests[event.index].id
                  )
                }
              >
                Accept
              </Button> */}
                  {/* <span className="reject">
                <img
                  onClick={() =>
                    this.changeStatusReject(
                      this.state.manageRequests[event.index].booking_id
                    )
                  }
                  src={reject}
                  alt="reject"
                />
              </span> */}
                  {/* <Button
                color="secondary"
                variant="contained"
                size="small"
                style={{ 
                  minWidth: "55px", 
                  fontSize : "12px",
                  marginLeft: "6%"
                }}
                onClick={() =>
                  this.changeStatusReject(
                    this.state.manageRequests[event.index].id
                  )
                }
              >
                Reject
              </Button> */}

                  {/* <Button 
               variant="contained" 
               color="primary"
               size="small"
               className={classes.button}
               style={ {marginRight: '10px'}}
               onClick={
                ()=>{
                  console.log(event,'props.original.booking_id')
                  this.setState({
                    showVerificationModel:true,
                    seatsToBeChangedValue: true,
                    seatsToBeChanged: event.original,
                    popText: "Do you want to approve this seat?",
                    showAcceptModal: true,
                    // showModal: true,
                    booking_id:event.original.id,
                    booking_status:"approved",
                    verificationTitle:'Do you want to approved the Verification of this booking ?'
                  })
                }}
              >
                Acceptrr
              </Button>
             
              <Button 
               variant="outlined"
               color="primary"
               size="small"
               className={classes.button}

               onClick={
                ()=>{
                  this.setState({
                    showVerificationModel:true,
                    seatsToBeChangedValue: false,
                    seatsToBeChanged: event.original,
                    popText: "Do you want to cancel this seat?",
                    showAcceptModal: true,
                    // showModalReject : true,
                    booking_id:event.original.id,
                    booking_status:"rejected",
                    verificationTitle:"Do You want to reject the Verification of this booking ?"
                  })
                }
               // ()=>this.updateBookingStatus(props.original.uuid,"rejected")

              }>
                Reject
              </Button> */}

                  <div
                    className="actions-center
              button_main"
                  >
                    <Button
                      color="primary"
                      variant="contained"
                      size="small"
                      onClick={(e) => {
                        // console.log(event,'e in onclick')
                        e.stopPropagation();
                        // console.log("87878788")
                        this.props.history.push(
                          "/admin/manageevent/eventregistrationDetails",
                          {
                            event: event.row,
                          }
                        );
                      }}
                    >
                      View
                    </Button>
                  </div>

                  {/* </div> */}
                  {/* :  */}
                </div>
              ) : event.original.booking_status == "WAITING" &&
                event.original.ticket_status != "REJECTED" ? (
                <div
                  className="actions-center
            button_main"
                >
                  <Button
                    variant="contained"
                    color="primary"
                    size="small"
                    className={classes.button}
                    style={{ marginRight: "10px" }}
                    onClick={() => {
                      this.setState({
                        //  showVerificationModel:true,
                        seatsToBeChangedValue: true,
                        seatsToBeChanged: event.original,
                        popText: "Do you want to approve this seat?",
                        showAcceptModal: true,
                        booking_status: "approved",
                        // showModal: true,
                        //  booking_id:event.original.id,
                        //  booking_status:"approved",
                        //  verificationTitle:'Do you want to approved the Verification of this booking ?'
                      });
                    }}
                  >
                    {event.original.ticket_type != "STUDENT"
                      ? "Accept"
                      : "Approve"}
                  </Button>

                  <Button
                    variant="outlined"
                    color="primary"
                    size="small"
                    className={classes.button}
                    style={{ marginRight: "10px" }}
                    onClick={
                      () => {
                        this.setState({
                          //  showVerificationModel:true,
                          seatsToBeChangedValue: false,
                          seatsToBeChanged: event.original,
                          popText: "Do you want to cancel this seat?",
                          showAcceptModal: true,
                          booking_status: "rejected",
                          // showModalReject : true,
                          //  booking_id:event.original.id,
                          //  booking_status:"rejected",
                          //  verificationTitle:"Do You want to reject the Verification of this booking ?"
                        });
                      }
                      // ()=>this.updateBookingStatus(props.original.uuid,"rejected")
                    }
                  >
                    Reject
                  </Button>

                  {event.original.ticket_type === "STUDENT" &&
                    (event.original.payment_mode === "offline" ||
                      event.original.payment_mode == "online") && (
                      <Button
                        color="primary"
                        variant="contained"
                        size="small"
                        className={classes.button}
                        onClick={(e) => {
                          // console.log(event,'e in onclick')
                          e.stopPropagation();
                          // console.log("87878788")
                          this.props.history.push(
                            "/admin/manageevent/eventregistrationDetails",
                            {
                              event: event.row,
                            }
                          );
                        }}
                      >
                        View
                      </Button>
                    )}
                </div>
              ) : (
                <div
                  className="actions-center
              button_main"
                >
                  <Button
                    color="primary"
                    variant="contained"
                    size="small"
                    onClick={(e) => {
                      // console.log(event,'e in onclick')
                      e.stopPropagation();
                      // console.log("87878788")
                      this.props.history.push(
                        "/admin/manageevent/eventregistrationDetails",
                        {
                          event: event.row,
                        }
                      );
                    }}
                  >
                    View
                  </Button>
                </div>
              )}
            </React.Fragment>
          );
        },
      },
    ];
    return column;
  };

  changeStatus = (bookingId) => {
    this.setState({
      showModal: true,
      booking_id: bookingId,
    });
  };

  changeStatusReject = (bookingId) => {
    this.setState({
      showModalReject: true,
      booking_id: bookingId,
    });
  };
  resetData = (column) => {
    const { id } = this.state;
    if (column === "bookingDetails") {
      this.setState(
        {
          ticket_type: "",
          user_type: "",
        },
        () => {
          // this.getNormalBookingData();
          this.getEvents(id);
        }
      );
    } else {
      this.setState(
        {
          ...this.state,
          ticket_type_manageRequest: "",
          user_type_manageRequest: "",
        },
        () => {
          // this.getNormalBookingData();
          this.getUnapprovedEvents(id);
        }
      );
    }

    this.getEvents(id);
  };

  changeUserOption = (e) => {
    // console.log('inside changeuseroption of eventDetails')
    this.setState(
      {
        selected_user_type: e && e,
      },
      //  ()=>this.getNormalBookingData())
      () => this.getEvents()
    );
  };

  changeTicketOption = (e) => {
    const { id } = this.state;
    console.log("insdie changeTicketOption");
    this.setState(
      {
        selected_ticket_type: e && e,
      },
      () => this.getEvents(id)
    );
    
  };
  cancelModalAccept = () => {
    this.setState({
      showAcceptModal: false,
      seatsToBeChangedValue: null,
      seatsToBeChanged: null,
      cancelModalreject: false,
    });
  };
  approveWaitingSeats = () => {
    let {
      seatsToBeChangedValue,
      seatsToBeChanged,
      booking_status,
      id,
    } = this.state;
    const { event } = this.props.location.state;

    this.setState({
      loader: true,
    });
    axios

      //  .post(`zoom/approveRejectWaitingListWebinar?webinar_id=${seatsToBeChanged.id}&registrant_uuid=${seatsToBeChanged.uuid}&accept=${seatsToBeChangedValue}`)
      .post(
        `booking/update/bookingsdetailsperBookingID/${seatsToBeChanged.id}/${booking_status}`
      )
      .then((res) => {
        if (res.status === 200 || res.status === 201) {
          if (seatsToBeChangedValue) {
            toastr.success("Waiting Registrant Accepted Successfully!");
            // setTimeout(function () { window.location.reload(); }, 2000);
            setTimeout(() => {
              this.props.history.push("/admin/manageevents/eventdetail", {
                redirect: true,
                event,
                redirected_event_id: event.id,
              });
              window.location.reload()
            }, 1000);
          } else {
            toastr.success("Waiting Registrant Rejected Successfully!");
            // setTimeout(function () { window.location.reload(); }, 1000);
            setTimeout(() => {
              this.props.history.push("/admin/manageevents/eventdetail", {
                redirect: true,
                event,
                redirected_event_id: event.id,
              });
              window.location.reload()
            }, 1000);
          }
          this.setState({
            loading: false,
            showAcceptModal: false,
          });
        }
      })
      .catch((error) => {
        if (error.response) {
          toastr.error(error.response.data.message);
          this.setState({
            ...this.state,
            showAcceptModal: false,
            loading: false,
          });
          // setTimeout(()=>{
          //   window.location.reload()
          //   },1000)
        } else {
          this.setState({
            loading: false,
          });
        }
      });
  };

  render() {
    const { classes, bookings, stateData } = this.props;
    const theme = withTheme();
    const {
      activeTab,
      name,
      amount,
      event_images,
      location,
      category_name,
      categoryList,
      // speakerList,
      // speaker_name,
      // speaker_bio,
      // speaker_image,
      start_date,
      end_date,
      price,
      brief_desc,
      editorState,
      waitingSeats,
      total_tickets,
      manageRequests,
      vipUsers,
      manageRequestsUsers,
      attendeesDetails,
      bookingDetails,
      showModal,
      showAcceptModal,
      showModalReject,
      remaining_tickets,
      booked_tickets,
      pending_tickets,
      survey_hash,
      speaker_details,
      eventId,
      id,
      waiting_tickets,
      actual_seats,
      loading,
      attendeesCount,
      event_type,
      group_booking_price,
      student_price,
      normal_price,
      early_bird_price,
      expiry_date,
      paymentTitle,
      showPaymentModel,
      verificationTitle,
      showVerificationModel,
      selected_user_type,
      selected_ticket_type,
      ticketTypeList,
      ticketTypeList1,
      userTypeList,
      userTypeList1,
      ticket_type,
      user_type,
      user_type_manageRequest,
      ticket_type_manageRequest,
      appovedUser,
      remaining_vip_seats,
      vip_seats,
    } = this.state;

    console.log(bookingDetails, stateData, bookings, "bookingDetails");
    return (
      <div className="manage-banner">
        <div className={classes.root}>
          <Card className="tabs_event">
            <AppBar position="static" color="default" className="tab-header">
              <Tabs
                value={activeTab}
                onChange={(event, index) => this.handleTab(index)}
                TabIndicatorProps={{
                  style: {
                    backgroundColor: "#c8102e",
                    color: "#c8102e",
                  },
                }}
                variant="fullWidth"
                centered
              >
                <Tab
                  icon={<Icon> view_module </Icon>}
                  label="General Details"
                  style={{
                    width: "100%",
                  }}
                />
                <Tab
                  icon={<Icon> view_module </Icon>}
                  label="Booking Details"
                  style={{
                    width: "100%",
                  }}
                />
                <Tab
                  icon={<Icon> view_module </Icon>}
                  label="Manage Requests"
                  style={{
                    width: "100%",
                  }}
                />
                <Tab
                  icon={<Icon> view_module </Icon>}
                  label="Vip Seats Bookings"
                  style={{
                    width: "100%",
                  }}
                />
                <Tab
                  icon={<Icon> view_module </Icon>}
                  label="Attendees"
                  style={{
                    width: "100%",
                  }}
                />
              </Tabs>
            </AppBar>

            <SwipeableViews
              axis={theme.direction === "rtl" ? "x-reverse" : "x"}
              index={activeTab}
              onChangeIndex={this.handleTab}
            >
              <TabContainer dir={theme.direction}>
                <div className="add-category-form">
                  <Card
                    className="{classes.card}"
                    style={{ overflow: "-webkit-paged-x" }}
                  >
                    <CardContent>
                      <GridContainer>
                        <GridItem md={12}>
                          <TextField
                            autoFocus
                            margin="dense"
                            id="survey_hash"
                            name="survey_hash"
                            label="Survey Id"
                            type="text"
                            fullWidth
                            value={survey_hash}
                            disabled={true}
                          />
                        </GridItem>
                        <GridItem md={12}>
                          <TextField
                            autoFocus
                            margin="dense"
                            id="event_name"
                            name="name"
                            label="Event Name"
                            type="text"
                            fullWidth
                            value={name}
                            disabled={true}
                          />
                        </GridItem>
                        <GridItem
                          md={12}
                          container
                          direction="column"
                          justify="center"
                          alignItems="center"
                          style={{ marginTop: "20px" }}
                        >
                          <legend>Banner Image</legend>
                          <img
                            className="banner_images_main"
                            src={event_images}
                            alt="banner_img"
                          ></img>
                        </GridItem>
                        <GridItem md={12}>
                          <TextField
                            InputLabelProps={{
                              shrink: location ? true : false,
                            }}
                            margin="dense"
                            id="location"
                            name="location"
                            label="Venue*"
                            type="text"
                            fullWidth
                            value={location}
                            disabled={true}
                          />
                        </GridItem>
                        <GridItem md={12}>
                          <legend style={{ fontSize: "1rem" }}>Category</legend>
                          <Select
                            isMulti
                            name="category"
                            options={categoryList}
                            value={category_name}
                            className="basic-multi-select"
                            classNamePrefix="select"
                            isDisabled={true}
                          />
                        </GridItem>
                        <GridItem className="date_text" md={6}>
                          <InputLabel shrink={true}>
                            Start Date &amp; Time
                          </InputLabel>
                          <DatePicker
                            selected={start_date}
                            showTimeSelect={true}
                            dateFormat="LLL"
                            minDate={new Date()}
                            placeholderText="Select Start Date"
                            disabled={true}
                          />
                        </GridItem>
                        <GridItem className="date_text" md={6}>
                          <InputLabel shrink={true}>
                            End Date &amp; Time
                          </InputLabel>
                          <DatePicker
                            selected={end_date}
                            showTimeSelect={true}
                            dateFormat="LLL"
                            minDate={
                              start_date !== null ? start_date : new Date()
                            }
                            placeholderText="Select End Date"
                            disabled={true}
                          />
                        </GridItem>
                        <GridItem className="brief_des" md={12}>
                          <TextField
                            InputLabelProps={{
                              shrink: brief_desc ? true : false,
                            }}
                            margin="dense"
                            id="brief_desc"
                            name="brief_desc"
                            label="Brief Description*"
                            type="text"
                            multiline={true}
                            fullWidth
                            value={brief_desc}
                            disabled={true}
                          />
                        </GridItem>
                        <GridItem md={12}>
                          <InputLabel shrink={true}>
                            Complete Description
                          </InputLabel>
                          {/* <Editor
                            wrapperClassName="wrapper-class"
                            editorClassName="editor-class"
                            toolbarClassName="toolbar-class"
                            editorState={editorState}
                            toolbar={{
                              image: {
                                uploadCallback: this.uploadImageCallBack,
                                alt: { present: true, mandatory: true }
                              }
                            }}
                            wrapperClassName="demo-wrapper"
                            editorClassName="demo-editor"
                            onEditorStateChange={editorState =>
                              this.setState({ editorState })
                            }
                            readOnly={true}
                          /> */}
                          <ReactQuill
                            onChange={(newValue, delta, source) => {
                              this.setState({ editorState: newValue });
                            }}
                            onBlur={(range, source, quill) => {
                              //console.log("onBlur quill.getHTML():::: ", quill.getHTML(), range, source,quill, quill.getLength(), quill.getText())
                              // console.log(quill.getHTML());
                            }}
                            modules={modules}
                            theme="snow"
                            value={editorState}
                          />
                        </GridItem>
                        {speaker_details &&
                          speaker_details.map((speaker, index) => (
                            <div className="speaker_list_details">
                              <GridItem md={12}>
                                <legend style={{ fontSize: "1rem" }}>
                                  Speaker(s) {index + 1}
                                </legend>

                                {/* <Select
                              isMulti
                              name="speaker"
                              options={speakerList}
                              value={speaker_name}
                              className="basic-multi-select"
                              classNamePrefix="select"
                              isDisabled={true}
                            /> */}
                                <TextField
                                  InputLabelProps={{
                                    shrink: brief_desc ? true : false,
                                  }}
                                  margin="dense"
                                  id="speaker_bio"
                                  name="speaker_bio"
                                  label="Speaker(s) Name"
                                  type="text"
                                  multiline={true}
                                  fullWidth
                                  value={speaker.speaker.name}
                                  disabled={true}
                                />
                              </GridItem>
                              <GridItem className="brief_des" md={12}>
                                <TextField
                                  InputLabelProps={{
                                    shrink: brief_desc ? true : false,
                                  }}
                                  margin="dense"
                                  id="speaker_bio"
                                  name="speaker_bio"
                                  label="Speaker(s) Bio"
                                  type="text"
                                  multiline={true}
                                  fullWidth
                                  value={speaker.speaker.bio}
                                  disabled={true}
                                />
                              </GridItem>
                              <GridItem
                                md={12}
                                container
                                direction="column"
                                justify="center"
                                alignItems="center"
                                style={{ marginTop: "20px" }}
                              >
                                <legend>Speaker Image </legend>
                                <img
                                  src={
                                    speaker.speaker.speaker_images.length > 0
                                      ? speaker.speaker.speaker_images[0].path
                                      : null
                                  }
                                  alt="speaker_img"
                                ></img>
                              </GridItem>
                            </div>
                          ))}
                        {event_type == "Paid" ? (
                          <Fragment>
                            {price ? (
                              <GridItem md={12}>
                                <TextField
                                  InputLabelProps={{
                                    shrink: price ? true : false,
                                  }}
                                  margin="dense"
                                  id="price"
                                  name="price"
                                  label="Price*"
                                  type="text"
                                  fullWidth
                                  value={price}
                                  disabled={true}
                                />
                              </GridItem>
                            ) : (
                              <Fragment>
                                <GridItem md={12}>
                                  <TextField
                                    InputLabelProps={{
                                      shrink: group_booking_price
                                        ? true
                                        : false,
                                    }}
                                    margin="dense"
                                    id="group_booking_price"
                                    name="group_booking_price"
                                    label="Group Booking Price*"
                                    type="text"
                                    fullWidth
                                    value={group_booking_price}
                                    disabled={true}
                                  />
                                </GridItem>
                                <GridItem md={12}>
                                  <TextField
                                    InputLabelProps={{
                                      shrink: student_price ? true : false,
                                    }}
                                    margin="dense"
                                    id="student_price"
                                    name="student_price"
                                    label="Student Price*"
                                    type="text"
                                    fullWidth
                                    value={student_price}
                                    disabled={true}
                                  />
                                </GridItem>
                                <GridItem md={12}>
                                  <TextField
                                    InputLabelProps={{
                                      shrink: normal_price ? true : false,
                                    }}
                                    margin="dense"
                                    id="normal_price"
                                    name="normal_price"
                                    label="Normal Price*"
                                    type="text"
                                    fullWidth
                                    value={normal_price}
                                    disabled={true}
                                  />
                                </GridItem>
                                {/* <div className="two_cols"> */}
                                <GridItem md={6}>
                                  <TextField
                                    InputLabelProps={{
                                      shrink: early_bird_price ? true : false,
                                    }}
                                    margin="dense"
                                    id="early_bird_price"
                                    name="early_bird_price"
                                    label="Early Bird Price*"
                                    type="text"
                                    fullWidth
                                    value={early_bird_price}
                                    disabled={true}
                                  />
                                </GridItem>
                                <GridItem className="date_text" md={6}>
                                  <InputLabel shrink={true}>
                                    Early Bird Expiry Date &amp; Time
                                  </InputLabel>
                                  <DatePicker
                                    selected={expiry_date}
                                    disabled={true}
                                    onChange={(date) => {
                                      let toISOString = date.toISOString();
                                      this.setState({
                                        expiry_time: toISOString,
                                        expiry_date: date,
                                      });
                                    }}
                                    showTimeSelect={true}
                                    dateFormat="LLL"
                                    // maxDate={setMaxDate}
                                    minDate={new Date()}
                                    placeholderText="Select Date"
                                  />
                                </GridItem>
                                {/* </div> */}
                              </Fragment>
                            )}
                          </Fragment>
                        ) : null}

                        <GridItem md={4}>
                          <TextField
                            InputLabelProps={{
                              shrink: actual_seats >= 0 ? true : false,
                            }}
                            margin="dense"
                            id="booked_tickets"
                            name="booked_tickets"
                            label="Actual Seats"
                            type="text"
                            fullWidth
                            value={actual_seats}
                            disabled={true}
                          />
                        </GridItem>

                        {/* {booked_tickets ? ( */}
                        <GridItem md={4}>
                          <TextField
                            InputLabelProps={{
                              shrink: booked_tickets >= 0 || booked_tickets == -1 ? true : false,
                            }}
                            margin="dense"
                            id="booked_tickets"
                            name="booked_tickets"
                            label="Booked Tickets*"
                            type="text"
                            fullWidth
                            value={booked_tickets}
                            disabled={true}
                          />
                        </GridItem>

                        <GridItem md={4}>
                          <TextField
                            InputLabelProps={{
                              shrink: pending_tickets >= 0 ? true : false,
                            }}
                            margin="dense"
                            id="pending_tickets"
                            name="pending_tickets"
                            label="Pending Tickets*"
                            type="text"
                            fullWidth
                            value={pending_tickets}
                            disabled={true}
                          />
                        </GridItem>
                        {/* ) : null} */}

                        {/* { */}
                        {/* remaining_tickets ? ( */}
                        <GridItem md={4}>
                          <TextField
                            InputLabelProps={{
                              shrink:
                                remaining_tickets || remaining_tickets == 0
                                  ? true
                                  : false,
                            }}
                            margin="dense"
                            id="remaining_tickets"
                            name="remaining_tickets"
                            label="Remaining Tickets*"
                            type="text"
                            fullWidth
                            value={remaining_tickets}
                            disabled={true}
                          />
                        </GridItem>
                        {/* // )  */}
                        {/* // : null} */}
                        <GridItem md={4}>
                          <TextField
                            InputLabelProps={{
                              shrink:
                                waitingSeats || waitingSeats === 0
                                  ? true
                                  : false,
                            }}
                            margin="dense"
                            id="waiting_seats"
                            name="waiting_seats"
                            label="Waiting Seats"
                            type="text"
                            fullWidth
                            value={waitingSeats}
                            disabled={true}
                          />
                        </GridItem>

                        <GridItem md={4}>
                          <TextField
                            InputLabelProps={{
                              shrink:
                                waiting_tickets || waiting_tickets >= 0
                                  ? true
                                  : false,
                            }}
                            margin="dense"
                            id="waiting_tickets"
                            name="waiting_tickets"
                            label="Booked Waiting Tickets"
                            type="text"
                            fullWidth
                            value={waiting_tickets}
                            disabled={true}
                          />
                        </GridItem>

                        <GridItem md={4}>
                          <TextField
                            InputLabelProps={{
                              shrink: total_tickets ? true : false,
                            }}
                            margin="dense"
                            id="total_tickets"
                            name="remaining_waiting_seates"
                            // label="Total Seats(Waiting + Normal)"
                            label="Remaining Waiting Seats"
                            type="text"
                            multiline={true}
                            fullWidth
                            value={
                              waitingSeats > waiting_tickets
                                ? waitingSeats - waiting_tickets
                                : waiting_tickets - waitingSeats
                            }
                            disabled={true}
                          />
                        </GridItem>
                        <GridItem md={4}>
                          <TextField
                            InputLabelProps={{
                              shrink: vip_seats ? true : false,
                            }}
                            margin="dense"
                            id="vip_seats"
                            name="vip_seats"
                            // label="Total Seats(Waiting + Normal)"
                            label="VIP Seats"
                            type="text"
                            multiline={true}
                            fullWidth
                            value={ vip_seats }
                            disabled={true}
                          />
                        </GridItem>
                        <GridItem md={4}>
                          <TextField
                            InputLabelProps={{
                              shrink: remaining_vip_seats ? true : false,
                            }}
                            margin="dense"
                            id="remaining_vip_seats"
                            name="remaining_vip_seats"
                            // label="Total Seats(Waiting + Normal)"
                            label="Remaining VIP Seats"
                            type="text"
                            multiline={true}
                            fullWidth
                            value={ remaining_vip_seats }
                            disabled={true}
                          />
                        </GridItem>
                      </GridContainer>
                    </CardContent>
                  </Card>
                </div>
              </TabContainer>
              <TabContainer dir={theme.direction}>
                <div class="add-category-form">
                  <div style={fiter_style}>
                    <FormControl
                      className={classes.formControl}
                      style={formStyle}
                    >

                      <Select
                        autoWidth
                        labelid="demo-simple-select-label"
                        id="demo-simple-select"
                        defaultValue={"Select User Type"}
                        value={ticket_type ? ticket_type : ""}
                        onChange={(selectedOption) => {
                          console.log(selectedOption, "selectedOption");
                          this.setState(
                            {
                              bookingDetails: appovedUser,
                              ticket_type: selectedOption,
                            },
                            () => {
                              const newbookingDetails = this.state.bookingDetails.filter(
                                (item) =>
                                  item.ticket_type
                                    .toLowerCase()
                                    .replace("_", " ")
                                    .includes(
                                      selectedOption.value.toLowerCase()
                                    )
                              );
                              this.setState({
                                bookingDetails: newbookingDetails,
                              });
                            }
                          );
                        }}
                        options={ticketTypeList}
                      >

                      </Select>
                    </FormControl>

                    <FormControl
                      className={classes.formControl}
                      style={formStyle}
                    >

                      <Select
                        autoWidth
                        labelid="demo-simple-select-label"
                        id="demo-simple-select"
                        value={user_type ? user_type : ""}
                        options={userTypeList}
                        onChange={(selectedOption) => {
                          // let { value } = event.target;
                          
                          this.setState(
                            {
                              bookingDetails: appovedUser,
                              user_type: selectedOption,
                            },
                            () => {
                              const newbookingDetails = this.state.bookingDetails.filter(
                                (item) =>
                                  item.registrant_type
                                    .toLowerCase()
                                    .replace("_", " ")
                                    .includes(
                                      selectedOption.value.toLowerCase()
                                    )
                              );
                              this.setState({
                                bookingDetails: newbookingDetails,
                              });
                            }
                          );
                        }}
                      ></Select>
                    </FormControl>
                    <ClearButton
                      onClick={() => {
                        this.resetData("bookingDetails");
                      }}
                      variant="contained"
                      color="iseas"
                    >
                      Clear Filter
                    </ClearButton>
                  </div>
                  <GridContainer>
                    <GridItem xs={12}>
                      <Card>
                        <CardBody>
                          <ReactTable
                            data={bookingDetails}
                            loading={bookings.loading}
                            columns={this.getBookingTableColumn()}
                            defaultPageSize={10}
                            pageSizeOptions={[5, 10, 20, 25, 50]}
                            showPaginationBottom={true}
                            minRows={0}
                            noDataText="No bookings found"
                            getTheadThProps={() =>
                              // state,
                              // rowInfo,
                              // column,
                              // instance
                              {
                                return {
                                  style: {
                                    marginBottom: "13px",
                                  },
                                };
                              }
                            }
                          />
                        </CardBody>
                      </Card>
                    </GridItem>
                  </GridContainer>
                </div>
              </TabContainer>

              <TabContainer dir={theme.direction}>
                <div class="add-category-form">
                  <GridContainer>
                    <GridItem xs={12}>
                      <Card>
                        <div style={fiter_style}>
                          <FormControl
                            className={classes.formControl}
                            style={formStyle}
                          >
                            {/* <InputLabel id="demo-simple-select-label">
                              Select Ticket Type
                            </InputLabel> */}
                            <Select
                              autoWidth
                              labelid="demo-simple-select-label"
                              id="demo-simple-select"
                              value={
                                ticket_type_manageRequest
                                  ? ticket_type_manageRequest
                                  : ""
                              }
                              options={ticketTypeList}
                              onChange={(selectedOption) => {
                                // let { value } = event.target;
                                
                                this.setState(
                                  {
                                    manageRequests: manageRequestsUsers,
                                    ticket_type_manageRequest: selectedOption,
                                  },
                                  () => {
                                    const newmanageRequests_ticketType = this.state.manageRequests.filter(
                                      (item) =>
                                        item.ticket_type
                                          .toLowerCase()
                                          .replace("_", " ")
                                          .includes(
                                            selectedOption.value.toLowerCase()
                                          )
                                    );
                                    this.setState({
                                      manageRequests: newmanageRequests_ticketType,
                                    });
                                  }
                                );
                              }}
                            ></Select>
                          </FormControl>

                          <FormControl
                            className={classes.formControl}
                            style={formStyle}
                          >

                            <Select
                              autoWidth
                              labelid="demo-simple-select-label"
                              id="demo-simple-select"
                              value={
                                user_type_manageRequest
                                  ? user_type_manageRequest
                                  : ""
                              }
                              options={userTypeList}
                              onChange={(selectedOption) => {
                                // let { value } = event.target;
                                
                                this.setState(
                                  {
                                    manageRequests: manageRequestsUsers,
                                    user_type_manageRequest: selectedOption,
                                  },
                                  () => {
                                    const newmanageRequests_userType = this.state.manageRequests.filter(
                                      (item) =>
                                        item.registrant_type
                                          .toLowerCase()
                                          .replace("_", " ")
                                          .includes(
                                            selectedOption.value.toLowerCase()
                                          )
                                    );
                                    this.setState({
                                      manageRequests: newmanageRequests_userType,
                                    });
                                  }
                                );
                              }}
                            ></Select>
                          </FormControl>
                          <ClearButton
                            onClick={() => {
                              this.resetData("manageRequest");
                            }}
                            variant="contained"
                            color="iseas"
                          >
                            Clear Filter
                          </ClearButton>
                        </div>
                        <CardBody>
                          <ReactTable
                            data={manageRequests}
                            columns={this.getManageRequestTableColumn()}
                            defaultPageSize={10}
                            pageSizeOptions={[5, 10, 20, 25, 50]}
                            showPaginationBottom={true}
                            minRows={0}
                            noDataText="No attendees found"
                            getTheadThProps={() =>
                              // state,
                              // rowInfo,
                              // column,
                              // instance
                              {
                                return {
                                  style: {
                                    marginBottom: "13px",
                                  },
                                };
                              }
                            }
                          />
                        </CardBody>
                      </Card>
                    </GridItem>
                  </GridContainer>
                </div>
              </TabContainer>
              <TabContainer dir={theme.direction}>
                <div class="add-category-form">
                  <GridContainer>
                    <GridItem xs={12}>
                      <Card>
                        <div style={fiter_style}>
                          <FormControl
                            className={classes.formControl}
                            style={formStyle}
                          >
                            {/* <InputLabel id="demo-simple-select-label">
                              Select Ticket Type
                            </InputLabel> */}
                            <Select
                              autoWidth
                              labelid="demo-simple-select-label"
                              id="demo-simple-select"
                              value={
                                ticket_type_manageRequest
                                  ? ticket_type_manageRequest
                                  : ""
                              }
                              options={ticketTypeList}
                              onChange={(selectedOption) => {
                                // let { value } = event.target;
                                
                                this.setState(
                                  {
                                    manageRequests: manageRequestsUsers,
                                    ticket_type_manageRequest: selectedOption,
                                  },
                                  () => {
                                    const newmanageRequests_ticketType = this.state.manageRequests.filter(
                                      (item) =>
                                        item.ticket_type
                                          .toLowerCase()
                                          .replace("_", " ")
                                          .includes(
                                            selectedOption.value.toLowerCase()
                                          )
                                    );
                                    this.setState({
                                      manageRequests: newmanageRequests_ticketType,
                                    });
                                  }
                                );
                              }}
                            ></Select>
                          </FormControl>

                          <FormControl
                            className={classes.formControl}
                            style={formStyle}
                          >

                            <Select
                              autoWidth
                              labelid="demo-simple-select-label"
                              id="demo-simple-select"
                              value={
                                user_type_manageRequest
                                  ? user_type_manageRequest
                                  : ""
                              }
                              options={userTypeList}
                              onChange={(selectedOption) => {
                                // let { value } = event.target;
                                
                                this.setState(
                                  {
                                    manageRequests: manageRequestsUsers,
                                    user_type_manageRequest: selectedOption,
                                  },
                                  () => {
                                    const newmanageRequests_userType = this.state.manageRequests.filter(
                                      (item) =>
                                        item.registrant_type
                                          .toLowerCase()
                                          .replace("_", " ")
                                          .includes(
                                            selectedOption.value.toLowerCase()
                                          )
                                    );
                                    this.setState({
                                      manageRequests: newmanageRequests_userType,
                                    });
                                  }
                                );
                              }}
                            ></Select>
                          </FormControl>
                          <ClearButton
                            onClick={() => {
                              this.resetData("manageRequest");
                            }}
                            variant="contained"
                            color="iseas"
                          >
                            Clear Filter
                          </ClearButton>
                        </div>
                        <CardBody>
                          <ReactTable
                            // data={manageRequests}
                            data={vipUsers}
                            columns={this.getVIPBookingColumn()}
                            defaultPageSize={10}
                            pageSizeOptions={[5, 10, 20, 25, 50]}
                            showPaginationBottom={true}
                            minRows={0}
                            noDataText="No VIP found"
                            getTheadThProps={() =>
                              // state,
                              // rowInfo,
                              // column,
                              // instance
                              {
                                return {
                                  style: {
                                    marginBottom: "13px",
                                  },
                                };
                              }
                            }
                          />
                        </CardBody>
                      </Card>
                    </GridItem>
                  </GridContainer>
                </div>
              </TabContainer>
              <TabContainer dir={theme.direction}>
                <div class="add-category-form">
                  <GridContainer>
                    <GridItem xs={12}>
                      <Card>
                        <CardBody>
                          <div className="count">
                            Attendees Count: {attendeesCount}
                          </div>

                          <ReactTable
                            // data={bookings.data}
                            // data = { bookingDetails }
                            data={attendeesDetails}
                            loading={bookings.loading}
                            columns={this.getAttendeesTableColumn()}
                            defaultPageSize={10}
                            pageSizeOptions={[5, 10, 20, 25, 50]}
                            showPaginationBottom={true}
                            minRows={0}
                            noDataText="No attendees found"
                            getTheadThProps={() =>
                              // state,
                              // rowInfo,
                              // column,
                              // instance
                              {
                                return {
                                  style: {
                                    marginBottom: "13px",
                                  },
                                };
                              }
                            }
                          />
                        </CardBody>
                      </Card>
                    </GridItem>
                  </GridContainer>
                </div>
              </TabContainer>
            </SwipeableViews>
          </Card>

          <DeleteModel
            title={paymentTitle}
            showModel={showPaymentModel}
            onCancel={() => {
              this.setState({
                showPaymentModel: false,
              });
            }}
            onOk={() => {
              this.updatePaymentStatus();
              this.setState({
                showPaymentModel: false,
                loading: true,
              });
            }}
          />

          <DeleteModel
            showModel={showModal}
            title={verificationTitle}
            onCancel={() => {
              this.setState({
                showModal: false,
                showVerificationModel: false,
                booking_id: null,
              });
            }}
            onOk={() => {
              let bookingId = this.state.booking_id;
              let status = "approved";
              this.setState({ loading: true, showModal: false });
              axios
                .post(
                  `booking/update/bookingsdetailsperBookingID/${bookingId}/${status}`
                )
                .then((res) => {
                  // debugger;
                  if (res.data.status === 200 || res.data.status === 201) {
                    // debugger;
                    this.setState({
                      loading: false,
                      booking_id: null,
                      activeTab: 3,
                    });
                    toastr.success(res.data.message);
                    this.getUnapprovedEvents(eventId);
                    window.location.reload();
                  } else if (res.data.status === 204) {
                    this.setState({
                      loading: false,
                      booking_id: null,
                      activeTab: 3,
                    });
                    toastr.error(res.data.message);
                  }
                })
                .catch((error) => {
                  this.setState({
                    loading: false,
                    booking_id: null,
                    activeTab: 3,
                  });
                  toastr.error(error.response.data.message);
                });
            }}
          />

          <DeleteModel
            // showModalReject={showModalReject}
            showModel={showVerificationModel}
            // showModalReject={showModalReject}
            title={verificationTitle}
            onCancel={() => {
              this.setState({
                showModalReject: false,
                showVerificationModel: false,
                booking_id: null,
              });
            }}
            // onOk={() => {
            //   let bookingId = this.state.booking_id;
            //   let status = "rejected";
            //   this.setState({ loading: true, showModalReject: false });
            //   axios
            //     .post(
            //       `booking/update/bookingsdetailsperBookingID/${bookingId}/${status}`
            //     )
            //     .then(res => {
            //       if (res.data.status === 200 || res.data.status === 201) {
            //         this.setState({
            //           loading: false,
            //           booking_id: null,
            //           activeTab: 3
            //         });
            //         toastr.success(res.data.message);
            //         this.getUnapprovedEvents(eventId);
            //         // window.location.reload();
            //       } else if (res.data.status === 204) {
            //         this.setState({
            //           loading: false,
            //           booking_id: null,
            //           activeTab: 3
            //         });
            //         toastr.error(res.data.message);
            //       }
            //     })
            //     .catch(error => {
            //       this.setState({
            //         loading: false,
            //         booking_id: null,
            //         activeTab: 3
            //       });
            //       toastr.error(error.response.data.message);
            //     });
            // }}
            onOk={() => {
              this.setState({
                ...this.state,
                loading: true,
              });
              this.updateEventBookingStatus();
              this.setState({
                showVerificationModel: false,
              });
            }}
          />
          <DeleteModel
            showModel={showAcceptModal}
            title={this.state.popText}
            onCancel={this.cancelModalAccept}
            onOk={() => {
              let { seatsToBeChangedValue, seatsToBeChanged } = this.state;
              this.approveWaitingSeats(seatsToBeChanged, seatsToBeChangedValue);
            }}
          />
          {loading && (
            <div className="loader_icon">
              <img src={loaderIcon} alt="loader" />
            </div>
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    bookings: state.bookings,
    stateData: state,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    handleGetEventBookings: (eventId) => {
      dispatch(getEventBookings$.trigger(eventId));
    },
    handleGetEventList: (body) => dispatch(getAllEvents$.trigger(body)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(extendedTablesStyle)(EventDetail));



// WEBPACK FOOTER //
// ./src/views/ISEAS/EventManagement/EventDetail.js